import { render } from "./DetailedSpendTypesGrid.vue?vue&type=template&id=6c6f3e21&scoped=true"
import script from "./DetailedSpendTypesGrid.vue?vue&type=script&lang=js"
export * from "./DetailedSpendTypesGrid.vue?vue&type=script&lang=js"

import "./DetailedSpendTypesGrid.vue?vue&type=style&index=0&id=6c6f3e21&lang=scss&scoped=true"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6f3e21"],['__file',"src/components/DetailedSpendTypesGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c6f3e21"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c6f3e21', __exports__)) {
    console.log('reload')
    api.reload('6c6f3e21', __exports__)
  }
  
  module.hot.accept("./DetailedSpendTypesGrid.vue?vue&type=template&id=6c6f3e21&scoped=true", () => {
    console.log('re-render')
    api.rerender('6c6f3e21', render)
  })

}


export default __exports__